<template>
  <Modal
    :open="modalState"
    :title="$t(titleKey)"
    footer-alignment="center"
    small
    @update:open="resolveConfirm(false)"
  >
    <div class="w-full bg-primary-100 text-primary-500 px-4 py-4 text-sm">
      {{ $t(bodyKey, { domains: blockedDomains }) }}
    </div>

    <template #footer>
      <CGButton variant="outline" @click="resolveConfirm(false)">{{ $t('General.Cancel') }}</CGButton>
      <CGButton @click="resolveConfirm(true)">
        {{ $t(proceedKey) }}
      </CGButton>
    </template>
  </Modal>
</template>

<script>
import { defineComponent } from 'vue';

/**
 * CG20-6122 - Confirmation asked when the backend CDN gatekeeper blocks a save.
 * Meant to be driven by $methods.saveWithCdnGuard: the caller keeps a ref to this
 * component and passes `confirm` as the guard's confirmFn.
 */
export default defineComponent({
  name: 'ExternalCdnConfirmModal',

  props: {
    titleKey: { type: String, required: true },
    bodyKey: { type: String, required: true },
    proceedKey: { type: String, required: true }
  },

  data() {
    return {
      modalState: false,
      blockedDomains: '',
      confirmResolve: null
    }
  },

  methods: {
    // Opens the modal and resolves once the user has chosen
    confirm(domains) {
      this.blockedDomains = domains
      this.modalState = true
      // The confirmation must not appear behind the spinner
      this.$eventBus.$emit('loading', false)
      return new Promise((resolve) => { this.confirmResolve = resolve })
    },
    resolveConfirm(confirmed) {
      this.modalState = false
      if (this.confirmResolve) this.confirmResolve(confirmed)
      this.confirmResolve = null
    }
  }
})
</script>
